import { IconButton, makeStyles } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  iconButton: {
    background: 'white',
    height: '12px',
    width: '15px',
    marginLeft: 6,
    padding: '0 !important',
    '&:hover': {
      backgroundColor: 'white'
    }
  },
  tabWarningIcon: {
    width: '20px !important',
    height: '20px !important',
    color: theme.palette.secondary.light
  }
}))

const FormWrapperCheckButton = () => {
  const classes = useStyles()
  return (
    <IconButton
      className={classes.iconButton}
      disableTouchRipple
      disableFocusRipple
      disableRipple
    >
      <CheckCircle className={classes.tabWarningIcon} />
    </IconButton>
  )
}

export default FormWrapperCheckButton
